import { getEdgeConfigWidget } from '../utils/edge-config-widget';

import { useEdgeConfig } from './use-edge-config';

export const useEdgeConfigWidget = <
  ConfigWidgetId extends keyof Edge.AllWidgetsByKey,
  ConfigWidgetModel extends Edge.AllWidgetsByKey[ConfigWidgetId],
>(
  widgetId: ConfigWidgetId,
): ConfigWidgetModel => {
  const edgeConfig = useEdgeConfig();

  return getEdgeConfigWidget<ConfigWidgetId, ConfigWidgetModel>(edgeConfig, widgetId);
};
